import APIResources from "../api/APIResources";
import APIAccounts from "./APIAccounts";
import APICRM from "./APICRM";
import APIDocumentations from "./APIDocumentations";
import APIDownloads from "./APIDownloads";
import APIFakeData from "./APIFakeData";
import APIFileManager from "./APIFileManager";
import APIFirstLineSupports from "./APIFirstLineSupports";
import APILicenses from "./APILicenses";
import APILicenseSeats from "./APILicenseSeats";
import APIMe from "./APIMe";
import APIProducts from "./APIProducts";
import APIProductTopics from "./APIProductTopic";
import APIProductTopicDownloads from "./APIProductTopicDownload";
import APIResourceCategories from "./APIResourceCategories";
import APIResourceTopics from "./APIResourceTopic";
import APIResourceTopicDownloads from "./APIResourceTopicDownload";
import APIS3Storage from "./APIS3Storage";
import APITerritories from "./APITerritories";
import APITickets from "./APITickets";
import APIUsers from "./APIUsers";

function mixin(...baseClasses: any[]): any {
  class Base {
    [key: string]: any;
  }

  baseClasses.forEach(baseClass => {
    Object.getOwnPropertyNames(baseClass.prototype).forEach(name => {
      if (name !== 'constructor') {
        Base.prototype[name] = baseClass.prototype[name];
      }
    });
  });

  return Base;
}

export default class API extends mixin(
  APIResources,
  APIS3Storage,
  APIResourceCategories,
  APIResourceTopics,
  APIResourceTopicDownloads,
  APIProducts,
  APIProductTopics,
  APIProductTopicDownloads,
  APIDownloads,
  APIDocumentations,
  APIFileManager,
  APIMe,
  APIAccounts,
  APITerritories,
  APIUsers,
  APIFirstLineSupports,
  APICRM,
  APILicenses,
  APILicenseSeats,
  APITickets,
  APIFakeData
) {

  token: string;
  constructor(token: string) {
    super();
    this.token = token;
    this.fetcher = this.fetcher.bind(this);
  }

  setToken(token: string) {
    this.token = token;
  }

  getHeadersWithContentType(contentType?: string | undefined) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${this.token}`);
    headers.append('Accept', 'application/json');
    if (contentType) {
      headers.append('Content-Type', contentType);
    }
    return headers;
  }

  getURLSearchParams(object: any) {
    const params = new URLSearchParams();
    if (object) {
      Object.keys(object).forEach((key: string) => {
        if (Array.isArray(object[key])) {
          object[key].forEach((value: string) => {
            params.append(`${key}[]`, value);
          });
        } else if (typeof (object[key]) === 'boolean') {
          params.append(key, object[key]);
        } else if (object[key]) {
          params.append(key, object[key]);
        }
      });
    }
    return params
  }

  async fetcher(url: string) {
    if (typeof window == 'undefined') {
      return Promise.resolve(false)
    }

    return fetch(url, {
      headers: new Headers({
        'Authorization': `Bearer ${this.token}`,
        'Accept': 'application/json',
        'Content-type': 'application/json',
      }),
    }).then(response => {
      if (!response.ok) {
        const error = Error(`Request failed with status ${response.status}`);
        error['status'] = response.status;
        throw error;
      }
      return response.json()
    })
  }
}
